import { createContext } from 'react';
import type { EventParamDecorated } from 'modules/tracking/GA4';

const TrackingParamsContext = createContext<EventParamDecorated[] | null>(null);

export default TrackingParamsContext;
